var map = {
	"./KOLDYE_TOU_Terms_of_Use_Rev_-_1-5-22.md": [
		593,
		593
	],
	"./KOLYDE_Cookie_Policy_1-5-22.md": [
		227,
		227
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 784;
module.exports = webpackAsyncContext;